import type { FontAwesomeBrandIcon, FontAwesomeIcon } from "../types/css"
import { brandIcons } from "./consts"

export function isUndefined(arg: any): arg is undefined {
  return typeof arg === "undefined"
}

export function isNullOrUndefined(arg: any): arg is null | undefined {
  return typeof arg === "undefined" || arg === null
}

export function isFunction(arg: any): arg is (...args: any[]) => any {
  return typeof arg === "function"
}

export function isBrandIcon(arg: FontAwesomeIcon): arg is FontAwesomeBrandIcon {
  return brandIcons.includes(arg)
}
